import type { IEntitlementsRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";
import type { Entitlement } from "@domain/schemas/BI";

@injectable()
export class GetEntitlementsService {
  @inject(TYPES.IEntitlementsRepository)
  private _entitlementsRepository!: IEntitlementsRepository;

  async getEntitlementsAsync(): Promise<Entitlement[]> {
    return this._entitlementsRepository.getEntitlementsAsync();
  }
}
